<template>
  <div class="withdraw_index">
    <div class="withdraw_index_nav">
      <navbar
        title="提现详情"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box" :class="{ notCreat_box: detailInfo.status == -1 }">
      <van-row>
        <img
          class="delect_icon"
          v-if="detailInfo.status == -1"
          @click="delect_record"
          src="@/assets/purchaseSupplier/common/delect.png"
        />
        <van-col span="24" class="title">提现金额</van-col>
        <van-col span="24" class="money">{{ detailInfo.balance }}</van-col>
        <van-col
          span="24"
          class="status notCreat"
          v-if="detailInfo.status == -1"
          >未发起提现</van-col
        >
        <van-col span="24" class="status success" v-if="detailInfo.status == 2"
          >提现成功</van-col
        >
        <van-col span="24" class="status" v-if="detailInfo.status == 1"
          >提现中</van-col
        >
        <van-col
          span="24"
          class="status"
          v-if="detailInfo.status == 3 || detailInfo.status == 6"
          >提现驳回</van-col
        >
        <van-col
          span="24"
          class="item"
          v-if="detailInfo.status == 3 || detailInfo.status == 6"
        >
          提现驳回原因
          <span class="reson">{{ detailInfo.reason }}</span>
        </van-col>
        <van-col span="24" class="item">
          提现方式
          <span v-if="detailInfo.type == 2">余额账户</span>
          <span v-if="detailInfo.type == 4">对公账户</span>
          <span v-if="detailInfo.type == 5">企业支付宝</span>
        </van-col>
        <van-col span="24" class="item">
          提现账户
          <span>{{ detailInfo.account }}</span>
        </van-col>
        <van-col
          span="24"
          class="item"
          v-if="
            detailInfo.status == 1 ||
            detailInfo.status == 3 ||
            detailInfo.status == 6
          "
        >
          提现单号
          <span>{{ detailInfo.ordersn }}</span>
        </van-col>
        <template v-if="detailInfo.status == -1">
          <van-col span="24" class="item">
            申请时间
            <span>{{ detailInfo.created_at }}</span>
          </van-col>
          <van-col span="24" class="item">
            关联的订单
            <span @click="bindedOrder">
              <img
                src="@/assets/purchaseSupplier/withdraw/bind_order.png"
              /><span class="bindedOrder"
                >订单金额￥{{ detailInfo.balance }}</span
              >
            </span>
          </van-col>
          <van-col span="24" class="item">
            发票类型
            <span class="radio_item">
              <span class="radio radio1">
                <img
                  class="radio_icon"
                  v-show="radioVal != 2"
                  @click="selectRadio(2)"
                  src="@/assets/purchaseSupplier/common/no_select.png"
                />
                <img
                  class="radio_icon"
                  v-show="radioVal == 2"
                  src="@/assets/purchaseSupplier/withdraw/radio_select.png"
                />
                纸质发票
              </span>
              <span class="radio">
                <img
                  class="radio_icon"
                  v-show="radioVal != 1"
                  @click="selectRadio(1)"
                  src="@/assets/purchaseSupplier/common/no_select.png"
                />
                <img
                  class="radio_icon"
                  v-show="radioVal == 1"
                  src="@/assets/purchaseSupplier/withdraw/radio_select.png"
                />
                电子发票
              </span>
            </span>
          </van-col>
          <van-col span="24" class="item">
            上传发票({{ fileList.length }}/5)
          </van-col>
          <van-col span="24" class="item">
            <div class="img_box">
              <van-uploader
                v-model="fileList"
                multiple
                :max-count="5"
                preview-size="64px"
                @oversize="onOversize"
                accept="image/jpeg, image/jpg, image/png"
                :after-read="afterRead"
                :before-read="beforeRead"
              >
                <div class="icon_box">
                  <div class="icon">+</div>
                  <div class="title"></div>
                </div>
              </van-uploader>
            </div>
          </van-col>
          <van-col span="24" class="item express_info" v-show="radioVal == 2">
            <van-field
              v-model="express"
              label="物流单号"
              placeholder="单行输入"
              input-align="right"
              onkeyup="value=value.replace(/[^\w]/ig,'')"
              onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
            />
          </van-col>
          <van-col
            span="24"
            class="item logistic_info express_info"
            @click="showExpress"
            v-show="radioVal == 2"
          >
            <span class="label">物流公司</span>
            <span class="sel_icon"><van-icon name="play" /></span>
            <span class="_select" v-if="!expressValue">请选择物流公司</span>
            <span class="_select val" v-else>{{ expressValue }}</span>
          </van-col>
          <van-col span="24" class="item" v-show="radioVal == 2">
            <van-field
              v-model="phone"
              label="寄件人手机号"
              placeholder="单行输入"
              input-align="right"
              type="number"
            />
          </van-col>
        </template>

        <template v-if="detailInfo.status > -1 && detailInfo.order_ids_group">
          <van-col span="24" class="item">
            关联的订单
            <span @click="bindedOrder">
              <img
                src="@/assets/purchaseSupplier/withdraw/bind_order.png"
              /><span class="bindedOrder"
                >订单金额￥{{ detailInfo.balance }}</span
              >
            </span>
          </van-col>
          <van-col span="24" class="item">
            发票类型
            <span v-if="detailInfo.contract_type == 1">电子发票</span>
            <span v-else>纸质发票</span>
          </van-col>
          <van-col span="24" class="item"> 上传发票 </van-col>
          <van-col span="24" class="item">
            <img
              v-for="(item, index) in detailInfo.invoice_image"
              :key="index"
              class="invoice_img"
              :src="item"
              @click="imgPreview(index)"
            />
          </van-col>
          <template v-if="detailInfo.contract_type == 2">
            <van-col span="24" class="item">
              物流单号
              <span>
                <img
                  class="copy"
                  @click="copylogistics(1)"
                  src="@/assets/purchaseSupplier/common/copy.png"
                />
                <span class="copy_text" ref="copytxt" @click="logistics">{{
                  detailInfo.logistics
                }}</span>
              </span>
            </van-col>
            <van-col span="24" class="item">
              物流公司
              <span>{{ detailInfo.logistics_company }}</span>
            </van-col>
            <van-col span="24" class="item">
              寄件人手机号
              <span>{{ detailInfo.tel }}</span>
            </van-col>
          </template>
        </template>

        <van-col span="24" class="item" v-if="detailInfo.status > -1">
          发起提现时间
          <span>{{ detailInfo.create_withdrawal_at }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.status == 2">
          提现完成时间
          <span>{{ detailInfo.withdrawal_at }}</span>
        </van-col>
        <van-col
          span="24"
          class="item"
          v-if="detailInfo.status == 3 || detailInfo.status == 6"
        >
          提现驳回时间
          <span>{{ detailInfo.withdrawal_at }}</span>
        </van-col>
      </van-row>
    </div>
    <div class="btn_box" v-if="detailInfo.status == -1">
      <btn
        :btntext="'复制链接开发票'"
        :btnwidth="'16.5rem'"
        :height="'4.4rem'"
        :bgcolor="'#fff'"
        :borderradius="'2.2rem'"
        :btncolor="'#333'"
        :btnborder="'solid 0.05rem #ccc'"
        :btnmargin="'0 1.3rem 0 0'"
        :fontsize="'1.6rem'"
        @btnClick="copylogistics(2)"
      />
      <span ref="copylink" class="copylink">{{ detailInfo.pdf_url }}</span>
      <btn
        :btntext="'发起提现'"
        :btnwidth="'16.5rem'"
        :height="'4.4rem'"
        :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
        :borderradius="'2.2rem'"
        :btncolor="'#fff'"
        :fontsize="'1.6rem'"
        @btnClick="confirm_withdraw"
      />
    </div>

    <van-popup class="showPopup" v-model="showPopup" position="bottom">
      <p class="popup_title">
        <img
          class="icon"
          v-show="!isMask"
          @click="changeStatus"
          src="@/assets/purchaseSupplier/withdraw/openEye.png"
        />
        <img
          class="icon"
          v-show="isMask"
          @click="changeStatus"
          src="@/assets/purchaseSupplier/withdraw/closeEye.png"
        />
        验证支付密码
        <img
          class="close"
          @click="closePopup"
          src="@/assets/purchaseSupplier/withdraw/close.png"
        />
      </p>
      <!-- 密码输入框 -->
      <van-password-input
        :value="passWord"
        :focused="showKeyboard"
        :gutter="6"
        :mask="isMask"
        @focus="showKeyboard = true"
      />
      <p class="tips">
        <span  @click="forgetPassWord">忘记密码</span>
      </p>
      <!-- 数字键盘 -->
      <!-- <van-number-keyboard
        v-model="passWord"
        :show="showKeyboard"
        @blur="showKeyboard = false"
      /> -->
      <van-number-keyboard
        v-model="passWord"
        :show="showKeyboard"
      />
    </van-popup>
    <div class="loading" v-if="loading">
      <img src="../../../assets/accountAgent/common/loading.gif" />
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
import { uploadMixin } from "../../debtRelief/mixin";
import Upload from "../../../providers/upload";
import { ImagePreview } from "vant";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      detailInfo: {},
      radioVal: 0,
      fileList: [],
      // fileList_: [],
      // fileList1: [],
      express: "",
      expressValue: "",
      selectItem: {},
      phone: "",
      isset: "",
      withdraw_info: {},
      showPopup: false,
      passWord: "",
      showKeyboard: false,
      isMask: true,
      withdraw_info_yh: {},
      loading: false
    };
  },
  created() {
    this.getInfo();
    this.selectItem = JSON.parse(localStorage.getItem("selectAddress"));
    if (this.selectItem) this.expressValue = this.selectItem.name;
    this.withdraw_info = JSON.parse(localStorage.getItem("withdraw_info"));
    this.isset = this.withdraw_info.isset;
    if (localStorage.getItem("withdraw_info_yh")) {
      this.withdraw_info_yh = JSON.parse(
        localStorage.getItem("withdraw_info_yh")
      );
      this.radioVal = this.withdraw_info_yh.radioVal;
      this.fileList = this.supplierWithdrawImg.filelist;
      this.express = this.withdraw_info_yh.express;
      this.phone = this.withdraw_info_yh.phone;
      localStorage.removeItem("withdraw_info_yh");
    }
  },
  watch: {
    passWord(value) {
      if (value.length === 6) {
        this.showPopup = false;
        this.submit(); //提交
      }
    },
    deep:true,
    immediate:true,
  },
  computed: {
    ...mapState({
      supplierWithdrawImg: (state) => state.supplierWithdrawImg,
    }),
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  mixins: [uploadMixin],
  methods: {
    goBack() {
      if (this.$route.query.from) {
        // this.$router.go(-2);
        this.$router.replace({
          path: "/purchaseSupplier/withdrawRecord",
          query: {
            id: this.$route.query.id,
          },
        });
      } else {
        this.$router.go(-1);
      }
    },
    getInfo() {
      this.$api
        .get("member-relation/member/supplier/withdrawal/detail", {
          id: this.$route.query.recordId,
        })
        .then((res) => {
          res.invoice_image = JSON.parse(res.invoice_image);
          this.detailInfo = res;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    bindedOrder() {
      this.$router.push({
        path: "/purchaseSupplier/bindedOrder",
        query: {
          orderIds: JSON.parse(this.detailInfo.order_ids_group),
          orderMoney: this.detailInfo.balance,
          date: this.detailInfo.created_at,
        },
      });
    },
    copylogistics(index) {
      const creditor_range = document.createRange();
      if (index == 1) {
        creditor_range.selectNode(this.$refs.copytxt);
      } else {
        creditor_range.selectNode(this.$refs.copylink);
      }
      const creditor_selection = window.getSelection();
      if (creditor_selection.rangeCount > 0)
        creditor_selection.removeAllRanges();
      creditor_selection.addRange(creditor_range);
      document.execCommand("Copy");
      if (index == 1) {
        this.$toast("复制成功");
      } else {
        this.$dialog
          .confirm({
            message:
              "复制成功，请粘贴到浏览器访问开具发票，并且上传到此处进行下一步操作",
            confirmButtonText: "确认",
            confirmButtonColor: "#F9591B",
            showCancelButton: false,
          })
          .then(() => {
            // on confirm
          });
      }
      creditor_selection.removeAllRanges();
    },
    delect_record() {
      this.$dialog
        .confirm({
          message: "确定删除此条记录吗？",
          confirmButtonText: "确认操作",
          confirmButtonColor: "#F9591B",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          this.$api
            .post(
              "member-relation/member/supplier/withdrawal/delete-withdrawal",
              {
                id: this.$route.query.recordId,
              }
            )
            .then((res) => {
              this.goBack();
            })
            .catch((err) => {
              this.passWord = "";
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
              } else {
                this.$toast(message);
              }
              return;
            });
        });
    },
    selectRadio(val) {
      this.radioVal = val;
    },
    confirm_withdraw() {
      if (this.radioVal == 0) {
        this.$toast("请选择发票类型");
        return;
      } else if (this.fileList.length == 0) {
        this.$toast("请上传发票");
        return;
      } else if (this.radioVal == 2 && !this.express) {
        this.$toast("请填写物流单号");
        return;
      } else if (this.radioVal == 2 && !this.selectItem.id) {
        this.$toast("请选择物流公司");
        return;
      } else if (this.radioVal == 2 && !this.phone) {
        this.$toast("请填写寄件人手机号");
        return;
      } else {
        if (this.isset == 1) {
          this.showKeyboard = true;
          this.showPopup = true;
        } else {
          this.showTips();
        }
      }
    },
    async submit() {
      this.loading = true;
      // if (this.fileList.length != 0) {
      //   let _files = await Upload.startUpload(
      //     this.fileList.map((_) => _.file),
      //     ["others"]
      //   );
      //   this.fileList_ = _files;
      // }
      let fileList_ = [];
      if (this.fileList.length != 0) {
        this.fileList.forEach((item) => {
          fileList_.push(item.src);
        });
      }
      this.$api
        .post("/member-relation/member/supplier/withdrawal/apply", {
          id: this.$route.query.recordId,
          supplier_id: this.$route.query.id,
          balance: this.detailInfo.balance,
          password: this.passWord,
          contract_type: this.radioVal,
          invoice_image: fileList_, //
          logistics_company: this.radioVal == 2 ? this.selectItem.name : "",
          // post_code: this.selectItem.code,
          logistics: this.radioVal == 2 ? this.express : "",
          tel: this.radioVal == 2 ? this.phone : "",
        })
        .then((res) => {
          this.$toast("提交成功");
          this.goBack();
        })
        .catch((err) => {
          this.passWord = "";
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    beforeRead(file) {
      if (file.size == 0 || JSON.stringify(file.file) == "{}") {
        //解决部分机型取消上传还是添加空白图片
        return false;
      } else {
        return true;
      }
    },
    afterRead(file) {
      if (Array.isArray(file)) {
        // 多选
        file.forEach((item) => {
          this.imgUpload(item);
        });
      } else {
        // 单选
        this.imgUpload(file);
      }
    },
    // 图片上传
    imgUpload(file) {
      file.status = "uploading";
      file.message = "上传中...";
      Upload.upload(file.file, ["others"])
        .then((res) => {
          file.status = "";
          file.message = "";
          file.src = res;
        })
        .catch((res) => {
          file.status = "failed";
          file.message = "失败";
        });
    },
    ...mapMutations(["setState"]),
    showExpress() {
      this.supplierWithdrawImg.filelist = this.fileList;
      let item = {
        radioVal: this.radioVal,
        // fileList: this.fileList,
        express: this.express,
        phone: this.phone,
      };
      localStorage.setItem("withdraw_info_yh", JSON.stringify(item));
      console.log(item);
      this.$router.push("/purchaseSupplier/logistics");
    },
    logistics() {
      localStorage.removeItem("delivery_address");
      this.$router.push({
        path: "/purchaseSupplier/logisticsDetail",
        query: {
          com: this.detailInfo.code,
          nu: this.detailInfo.logistics,
          name: this.detailInfo.logistics_company,
          phone: this.detailInfo.tel,
        },
      });
    },
    showTips() {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "您还未设置支付密码，为了您的账号安全，请先前往设置支付密码",
          confirmButtonText: "设置",
          confirmButtonColor: "#F9591B",
          cancelButtonText: "取消",
          cancelButtonColor: "#333",
        })
        .then(() => {
          // on confirm
          this.params("", "", "setPassWord");
        })
        .catch(() => {
          // on cancel
        });
    },
    forgetPassWord() {
      this.params("", "", "forgetPassWord");
    },
    changeStatus() {
      this.isMask = !this.isMask;
    },
    closePopup() {
      this.showPopup = false;
      this.passWord = "";
    },
    imgPreview(index) {
      ImagePreview({
        images: this.detailInfo.invoice_image,
        startPosition: index,
      });
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.withdraw_index {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .withdraw_index_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    padding: 10.4rem 1.6rem 1rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .van-row {
      min-height: 31.2rem;
      padding: 3rem 2rem 0;
      background: #fff;
      border-radius: 0.8rem;
      box-sizing: border-box;
      position: relative;

      .delect_icon {
        width: 1.5rem;
        position: absolute;
        top: 1.4rem;
        right: 1.4rem;
      }

      .title {
        color: #999;
        font-size: 1.2rem;
        line-height: 1.7rem;
        text-align: center;
      }

      .money {
        color: #333;
        font-size: 3.2rem;
        line-height: 3.7rem;
        font-weight: 700;
        text-align: center;
        margin: 0.4rem 0 0.6rem;
      }

      .status {
        color: #ff4747;
        font-size: 1.4rem;
        line-height: 2rem;
        text-align: center;
        margin-bottom: 5.6rem;
      }

      .success {
        color: #333;
      }

      .notCreat {
        color: #4988fd;
      }

      .item {
        line-height: 2rem;
        color: #999;
        font-size: 1.4rem;
        margin-bottom: 1.4rem;

        .invoice_img {
          width: 6.4rem;
          height: 6.4rem;
          margin-right: 1.5rem;
        }
        .invoice_img:nth-child(4) {
          margin: 0;
        }

        span {
          color: #333;
          font-size: 1.4rem;
          float: right;
          max-width: 18.7rem;
          text-align: right;

          img {
            width: 1.5rem;
            margin-right: 0.6rem;
            vertical-align: middle;
          }

          .bindedOrder {
            color: #4988fd;
            font-size: 1.4rem;
            font-weight: 700;
            line-height: 1.3rem;
            margin-top: 0.3rem;
            border-bottom: solid 1px #4988fd;
          }

          .copy_text {
            color: #4988fd;
          }

          .copy {
            width: 2rem;
            margin-left: 0.6rem;
            margin-right: 0;
            vertical-align: middle;
            float: right;
          }
        }

        .reson {
          color: #ff4747;
        }

        .radio_item {
          max-width: 21.7rem;

          .radio {
            img {
              width: 1.6rem;
              margin-right: 0.6rem;
              vertical-align: middle;
            }
          }

          .radio1 {
            margin-left: 3.8rem;
          }
        }

        .van-uploader {
          width: 100%;

          .van-uploader__input-wrapper {
            width: 6.4rem;
            padding-right: 1rem;

            .icon_box {
              width: 6.4rem;
              height: 6.4rem;
              border: dashed 0.1rem #999;

              .icon {
                font-size: 1.6rem;
                font-weight: 700;
                text-align: center;
                margin-top: 2.3rem;
              }
            }

            .van-uploader__preview {
              width: 6.4rem;
              margin-right: 1rem;

              .van-uploader__preview-image {
                width: 6.4rem;
              }

              .van-uploader__preview-delete {
                width: 2.2rem;
                height: 2.2rem;
                border-radius: 0 0.8rem;
              }

              .van-uploader__preview-delete-icon {
                top: 0.1rem;
                right: 0.1rem;
                font-weight: 700;
                font-size: 2rem;
              }
            }

            .van-image__img,
            .van-image__error,
            .van-image__loading {
              object-fit: fill !important;
              width: 6.4rem;
            }
          }
        }

        .van-cell {
          padding: 0;

          /deep/.van-field__label {
            color: #999;
          }
        }
      }

      .logistic_info {
        span {
          display: inline-block;
          text-align: right;
          float: left;
        }

        ._select {
          width: calc(100% - 9rem);
          color: #999;
          font-weight: 400;
          text-align: right;
          float: right;
        }

        .label {
          width: 9rem;
          text-align: left;
          color: #999;
        }

        .sel_icon {
          float: right;
          color: #333;
          width: 1.3rem;
          margin-left: 0.4rem;
          transform: translateY(-3px);
          transform: rotate(90deg);
          -ms-transform: rotate(90deg); /* IE 9 */
          -moz-transform: rotate(90deg); /* Firefox */
          -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
          -o-transform: rotate(90deg);
        }

        .val {
          color: #333;
        }
      }

      .express_info {
        padding-bottom: 1.4rem;
        border-bottom: solid 0.1rem #eaeaea;
      }
    }
  }

  .notCreat_box {
    padding-bottom: 7rem;
  }

  .btn_box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    height: 5.6rem;
    padding: 0.4rem 1.6rem 0;

    .copylink {
      width: 0;
      height: 0;
      font-size: 0;
      display: inline;
    }
  }

  .showPopup {
    min-height: 387px;

    .popup_title {
      text-align: center;
      color: #333;
      font-size: 16px;
      padding: 0 13px;
      line-height: 56px;

      .icon {
        width: 20px;
        margin-right: 6px;
        vertical-align: middle;
      }

      .close {
        width: 22px;
        float: right;
        margin-top: 17px;
      }
    }

    .tips {
      height: 36px;
      padding: 0 10px;
      box-sizing: border-box;

      span {
        color: #999;
        font-size: 12px;
        line-height: 19px;
        float: right;
        padding: 9px;
      }
    }

    .van-password-input__item {
      border: solid 1px #e5e5e5;
      border-radius: 5px;
    }

    .van-password-input__item--focus {
      border-color: #f9591b;

      .van-password-input__cursor {
        background-color: #f9591b;
      }
    }
  }

  .loading {
    width: 100%;
    /*padding-top: 100px;*/
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);

    img {
      width: 35%;
      margin-top: 50%;
    }
  }
}
</style>


